import config from '@/config'
import axios from 'axios'
import { preferredPaymentMethodsMap } from '@/helpers/constants'

export default {
	namespaced: true,

	state: {
		purchasedProduct: null,
		upgrades: {
			original: null,
			discounted: null,
		},
		promocode: null,
		removeDiscountAfterCountdown: null,
		overridenTabsOrder: null,
		overridenDefaultPaymentTab: null,
		countdown: null,
		countdownIsVisible: false,
		countdownFinishedAt: null,
		seamlessPurchase: {
			enabled: false,
			loading: false,
			passed: false,
		},
		freeWorkbook: {
			id: null,
			title: null,
			campaignID: null,
		},
		lastUsedProvider: null,
		taxes: {
			initialized: false,
			paidByUser: false,
			coverageModalOpen: false,
		},
	},

	mutations: {
		setPurchasedProduct(state, product) {
			state.purchasedProduct = product
		},

		setUpgrades(state, upgrades) {
			state.upgrades.original = upgrades?.original
			state.upgrades.discounted = upgrades?.discounted
		},

		setPromocode(state, promocode) {
			state.promocode = promocode
		},

		setRemoveDiscountAfterCountdown(state, status) {
			state.removeDiscountAfterCountdown = status
		},

		setOverridenTabs(state, preferredPaymentMethod) {
			if (!preferredPaymentMethodsMap[preferredPaymentMethod]) {
				return
			}

			state.overridenTabsOrder = preferredPaymentMethodsMap[preferredPaymentMethod].tabsOrder
			state.overridenDefaultPaymentTab = preferredPaymentMethodsMap[preferredPaymentMethod].defaultPaymentTab
		},

		updateCountdown(state, value) {
			state.countdown = value
		},

		toggleCountdown(state, value) {
			state.countdownIsVisible = value
		},

		setCountdownFinishedAt(state, finishedAt) {
			state.countdownFinishedAt = finishedAt
		},

		setSeamlessPurchase(state, { enabled, loading, passed }) {
			if (enabled !== undefined) {
				state.seamlessPurchase.enabled = enabled
			}
			if (loading !== undefined) {
				state.seamlessPurchase.loading = loading
			}
			if (passed !== undefined) {
				state.seamlessPurchase.passed = passed
			}
		},

		setFreeWorkbook(state, { id, title, campaignID }) {
			state.freeWorkbook = {
				id,
				title,
				campaignID,
			}
		},

		setLastUsedProvider(state, provider) {
			state.lastUsedProvider = provider
		},

		setTaxesInitialized(state, value) {
			state.taxes.initialized = value
		},

		setTaxPaidByUser(state, value) {
			state.taxes.paidByUser = value
		},

		setTaxCoverageModalOpen(state, value) {
			state.taxes.coverageModalOpen = value
		},
	},

	getters: {
		getPromocode(state) {
			return state.promocode
		},

		getSeamlessPurchase(state) {
			return state.seamlessPurchase
		},

		getFreeWorkbook(state) {
			return state.freeWorkbook
		},

		getLastUsedProvider(state) {
			return state.lastUsedProvider
		},
	},

	actions: {
		async setPromocodeByName({ commit }, promocode) {
			try {
				const { data } = await axios.get(`${config('SimpleAPIUrl')}v1/api/marketing/promocode`, {
					params: {
						promocode,
					},
				})

				commit('setPromocode', data)
			} catch (e) {
				commit('setPromocode', null)
				throw e
			}
		},
	},
}
